/**
 * Copyright (c) 2016-2020 Yega Yazilim ve Bilisim Hizmetleri Dis Tic Ltd Sti
 * All Rights Reserved.
 *
 * The software and data contained herein are confidential and
 * proprietary information of Yega Yazilim ("Confidential Information").
 *
 * Users of this software may not disclose such Confidential Information
 * and shall use it only in accordance with the terms of the license agreement
 * they entered into with Yega Yazilim.
 *
 *
 * Author    Ahmet Dogramaci
 * Date      2020-03-16
 */

import ConfigurationTemplateNode from "./configuration-template-node.js"
import ConfigurationTemplateDecision from "./configuration-template-decision"
import ConfigurationTemplateOrGroup from "./configuration-template-or-group";

class ConfigurationTemplateVersion {
    constructor() {
        this.nodes = [];
        this.decisions = [];
        this.or_groups = [];
        this.attribute_store = {};
        this.nodes_by_id = {};
        this.nodes_by_cfg_item_id = {};
        this.name = '';
    }

    buildFromJson(json){
        this.id = json.id;
        this.current_version_id = json.current_version_id;
        this.name = json.name;
        this.attribute_store = json.attribute_store;
        this.buildNodes(json.cfg_template_nodes);
        this.buildDecisions(json.cfg_template_decs);
        this.buildOrGroups(json.cfg_template_or_groups);
    }

    initialize(){
        this.or_groups.forEach((or_group)=>{
            or_group.evaluateStatus();
        });
        this.decisions.forEach((decision)=>{
            decision.evaluateWatchStatus();
        });
    }

    buildNodes(nodes_json){
        nodes_json.forEach((node_json)=>{
            let template_node = new ConfigurationTemplateNode();
            template_node.setTemplateVersion(this);
            template_node.buildFromJson(node_json);
            this.addNode(template_node);
        });
    }

    buildDecisions(decisions_json){
        decisions_json.forEach((decision_json)=>{
            let decision = new ConfigurationTemplateDecision();
            decision.template_version = this;
            decision.buildFromJson(decision_json);
            this.addDecision(decision);
        });
    }

    buildOrGroups(or_groups_json){
        or_groups_json.forEach((json_object)=>{
            let or_group = new ConfigurationTemplateOrGroup();
            or_group.template_version = this;
            or_group.buildFromJson(json_object);
            this.addOrGroup(or_group);
        });
    }

    addNode(node){
        this.nodes.push(node);
        this.nodes_by_id[node.id]=node;
        this.nodes_by_cfg_item_id[node.cfg_item_id]=node;
    }

    addDecision(decision){
        this.decisions.push(decision);
    }

    addOrGroup(or_group){
        this.or_groups.push(or_group);
    }

    getNodeById(id){
        return this.nodes_by_id[id];
    }

    getNodeByCfgItemId(cfg_item_id){
        return this.nodes_by_cfg_item_id[cfg_item_id];
    }

    selectNodes(cfg_item_ids){
        cfg_item_ids.forEach((cfg_item_id)=>{
            this.getNodeByCfgItemId(cfg_item_id).select();
        });
    }

    get selected_nodes(){
        return this.nodes.filter((node)=>{ return node.isSelected;});
    }

    resetNodeTraces(){
        this.nodes.forEach((node)=>{
            node.resetTraces();
        });
    }
}
export default ConfigurationTemplateVersion;
